export default "__VITE_ASSET__DlR$0WJn__"